import { useEffect } from "react";
import { useFormatTemplateStore } from "@/state/formatTemplateStore";
import DropdownMenuField from "@/components/ui/DropdownMenuField";
import {
  DateFormatItemsList,
  decimalPointsForSharePriceList,
  NumericalFormatItemsList,
  percentageFormatItemsList,
} from "@/utils/formatTemplate/formatTemplate";
import SectionHeader from "@/components/ui/SectionHeader";
import InputField from "@/components/ui/InputField";
import Ring from "@/components/ui/Ring";

export default function NumericalSelectionStep() {
  const numericalSelection = useFormatTemplateStore((state) => state.numericalSelection);
  const { updateNumericalSelection, markAnswered, currentStep } = useFormatTemplateStore();

  useEffect(() => {
    currentStep === 4 && markAnswered(4);
  }, [currentStep]);

  return (
    <Ring className={"p-4 mt-10 flex flex-col gap-8"}>
      <p>This is the base numerical formatting terminology that will be applied in charts and table creation.</p>
      <div className={"w-4/5 flex flex-col gap-4"}>
        <DropdownMenuField
          title="Numerical Formats"
          itemslist={NumericalFormatItemsList}
          initialValue={numericalSelection.numericalFormats}
          onSelect={(value: string) => updateNumericalSelection("numericalFormats", value)}
          text={
            <p>
              We will add an associated currency symbol in front of the Numerical format provided here for currency
              values.
            </p>
          }
        />

        <DropdownMenuField
          title="Decimals Points for Share Price"
          itemslist={decimalPointsForSharePriceList}
          initialValue={numericalSelection.decimalsForSharePrice}
          onSelect={(value: string) => updateNumericalSelection("decimalsForSharePrice", value)}
        />

        <DropdownMenuField
          title="Date Format for Charts"
          itemslist={DateFormatItemsList}
          initialValue={numericalSelection.dateFormatForCharts}
          onSelect={(value: string) => updateNumericalSelection("dateFormatForCharts", value)}
        />

        <DropdownMenuField
          title="Percentage Value Formats"
          itemslist={percentageFormatItemsList}
          initialValue={numericalSelection.percentageValueFormats}
          onSelect={(value: string) => updateNumericalSelection("percentageValueFormats", value)}
        />

        <div className={"w-4/5"}>
          <SectionHeader title="Numerical Short Terminology" type="secondary" />
        </div>

        <InputField
          maxLength={130}
          title="Thousands Short"
          initialValue={numericalSelection.thousandsShort}
          onChange={(value: string) => updateNumericalSelection("thousandsShort", value)}
        />

        <InputField
          maxLength={130}
          title="Millions Short"
          initialValue={numericalSelection.millionsShort}
          onChange={(value: string) => updateNumericalSelection("millionsShort", value)}
        />

        <InputField
          maxLength={130}
          title="Billions Short"
          initialValue={numericalSelection.billionsShort}
          onChange={(value: string) => updateNumericalSelection("billionsShort", value)}
        />

        <InputField
          maxLength={130}
          title="Trillions Short"
          initialValue={numericalSelection.trillionsShort}
          onChange={(value: string) => updateNumericalSelection("trillionsShort", value)}
        />

        <div className={"w-4/5"}>
          <SectionHeader title="Financial Terminology" type="secondary" />
        </div>
        <InputField
          maxLength={130}
          title="Enterprise Value Naming"
          initialValue={numericalSelection.enterpriseValueNaming}
          onChange={(value: string) => updateNumericalSelection("enterpriseValueNaming", value)}
        />

        <InputField
          maxLength={130}
          title="Enterprise Value Short"
          initialValue={numericalSelection.enterpriseValueShort}
          onChange={(value: string) => updateNumericalSelection("enterpriseValueShort", value)}
        />

        <InputField
          maxLength={130}
          title="Equity Value Naming"
          initialValue={numericalSelection.equityValueNaming}
          onChange={(value: string) => updateNumericalSelection("equityValueNaming", value)}
        />

        <InputField
          maxLength={130}
          title="Equity Value Short"
          initialValue={numericalSelection.equityValueShort}
          onChange={(value: string) => updateNumericalSelection("equityValueShort", value)}
        />
      </div>
    </Ring>
  );
}
